var exports = {
  "kL": "ChannelInvitesTab.module__container___X1N0Nk",
  "wx": "ChannelInvitesTab.module__header___X1N0Nk",
  "h_": "ChannelInvitesTab.module__description___X1N0Nk",
  "GC": "ChannelInvitesTab.module__buttonGroup___X1N0Nk",
  "dc": "ChannelInvitesTab.module__spinnerContainer___X1N0Nk",
  "sJ": "ChannelInvitesTab.module__invitesContainer___X1N0Nk",
  "$h": "ChannelInvitesTab.module__invitesList___X1N0Nk",
  "eu": "ChannelInvitesTab.module__inviteItems___X1N0Nk",
};

module.exports = exports;
